import { BuilderConfig } from '../../../types/Builder';

import B2BIntegrations, { B2BIntegrationsProps } from './b2b-integrations';

export const B2BIntegrationsBuilderConfig = {
    name: 'B2B Integrations',
    inputs: [
        {
            name: 'title',
            type: 'string',
        },
        {
            name: 'sections',
            type: 'list',
            copyOnAdd: false,
            subFields: [
                {
                    name: 'title',
                    type: 'string',
                },
                {
                    name: 'brands',
                    type: 'list',
                    copyOnAdd: false,
                    subFields: [
                        {
                            name: 'name',
                            type: 'string',
                        },
                        {
                            name: 'link',
                            type: 'url',
                        },
                        {
                            name: 'logo',
                            type: 'file',
                        },
                        {
                            name: 'width',
                            type: 'number',
                        },
                        {
                            name: 'height',
                            type: 'number',
                        },
                    ],
                },
            ],
        },
    ],
};

const builderConfig: BuilderConfig<B2BIntegrationsProps> = {
    component: B2BIntegrations,
    config: B2BIntegrationsBuilderConfig,
};

export default builderConfig;
